import { useMemo } from 'react'

import { useConfigurationContext } from '../context/configurationContext'
import { useMetaModelContext } from '../context/metaModelContext'
import { useNavigationParams } from '../system/useNavigationParams'
import { getApplicationViewParameterDefinitions } from './helpers'
import { useOperationsContext } from './operationsContext'

export const useApplicationViewParameterDefinitions = () => {
  const { layer, block } = useNavigationParams()
  const { parameterDefinitionCreateOperations } = useOperationsContext()
  const { layerTopology, blockTopology } = useMetaModelContext()
  const { viewAt } = useConfigurationContext()
  return useMemo(
    () =>
      getApplicationViewParameterDefinitions({
        parameterDefinitionCreateOperations,
        layer,
        block,
        layerTopology,
        blockTopology,
        viewAt,
      }),
    [
      parameterDefinitionCreateOperations,
      layer,
      block,
      layerTopology,
      blockTopology,
      viewAt,
    ],
  )
}
